import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { TicketType } from "@faire/help-center-self-serve/consts";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { browserLevelLocaleKey } from "@faire/help-center-utils/serialized-data/getLocale";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getRetailerOrBrandCountry } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandCountry";
import { getSettingChatMessengerWindowLogoUrl } from "@faire/help-center-utils/settings/getSettingChatMessengerWindowLogoUrl";
import { getSettingChatMessengerWindowTitle } from "@faire/help-center-utils/settings/getSettingChatMessengerWindowTitle";
import { getSettingSunCoIntegrationId } from "@faire/help-center-utils/settings/getSettingSunCoIntegrationId";
import fetchJwtAuth from "@faire/web-api/api/help-center/messenger/auth/get";
import fetchConversation from "@faire/web-api/api/help-center/messenger/conversation/get";
import { trackHelpCenterAllTypesOfTicketCreationSubmit } from "@faire/web-api/events/helpCenter/submit/allTypesOfTicketCreation";
import { trackHelpCenterChatCsatSubmit } from "@faire/web-api/events/helpCenter/submit/chatCsat";
import { trackHelpCenterChatCsatView } from "@faire/web-api/events/helpCenter/view/chatCsat";
import { buildLocale } from "@faire/web/common/localization/utils";
import { logWarning } from "@faire/web/common/logging";
import { Storage } from "@faire/web/common/Storage";
import Smooch from "smooch";
import { addHotjarToIframeAttribute, displayTopBanner, hideInputField, hideTopBanner, removeSunCoLogo, showInputField } from "./chatCssOverrides";
import { ANSWER_BOT_NAME, FAIRE_BOT_NAME, FAIRE_BOT_ROLE, FAIRE_CHAT_CSAT_FEEDBACK_SUBMITTED_STORAGE_KEY, FAIRE_CHAT_METADATA, INIT_SEND_FAIRE_BOT_PROMPT_MESSAGE, MessagePayload } from "./consts";
import { customTexts } from "./customTexts";
var zdAgentInfo = {
  agentName: "",
  ticketId: ""
};
var ChatError = /*#__PURE__*/function (_Error) {
  function ChatError(error) {
    var _this;
    _classCallCheck(this, ChatError);
    _this = _callSuper(this, ChatError);
    _this.message = "Chat Error: ".concat(error === null || error === void 0 ? void 0 : error.message);
    _this.name = "ChatError";
    _this.stack = error === null || error === void 0 ? void 0 : error.stack;
    return _this;
  }
  _inherits(ChatError, _Error);
  return _createClass(ChatError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var initChatWidget = function initChatWidget(auth, strictLocalize, metaData) {
  if (!getSettingSunCoIntegrationId()) {
    var error = new Error("Chat widget is not enabled for the user");
    return Promise.reject(error);
  }
  // Initialize Smooch and set up the chat widget style to match Faire's style
  return Smooch.init({
    integrationId: getSettingSunCoIntegrationId(),
    jwt: auth.jwt,
    externalId: auth.external_id,
    locale: buildLocale(browserLevelLocaleKey()),
    embedded: false,
    displayStyle: "button",
    fixedHeader: true,
    businessIconUrl: getSettingChatMessengerWindowLogoUrl(),
    businessName: getSettingChatMessengerWindowTitle(),
    menuItems: {
      imageUpload: true,
      fileUpload: true,
      shareLocation: false
    },
    canUserSeeConversationList: false,
    customColors: {
      conversationColor: "333333",
      brandColor: "FFFFFF",
      actionColor: "333333"
    },
    customText: _objectSpread({}, customTexts(strictLocalize)),
    buttonIconUrl: "https://cdn.faire.com/fastly/a2ede5d047279d3d307e2861c07ee6e429a5b28c411621f2d5fd648d735409e2.png",
    delegate: {
      beforeDisplay: function beforeDisplay(message, _data) {
        var text = message.text,
          displayName = message.displayName,
          payload = message.payload;
        if (displayName === ANSWER_BOT_NAME || payload === MessagePayload.INIT_SEND_FAIRE_BOT_PROMPT) {
          return null;
        }
        if (displayName === FAIRE_BOT_NAME && payload === MessagePayload.CSAT_MESSAGE) {
          var _message$metadata, _message$metadata2, _message$metadata3;
          zdAgentInfo.agentName = "".concat((_message$metadata = message.metadata) === null || _message$metadata === void 0 ? void 0 : _message$metadata.ticketAssigneeFirstName, " ").concat((_message$metadata2 = message.metadata) === null || _message$metadata2 === void 0 ? void 0 : _message$metadata2.ticketAssigneeLastName);
          zdAgentInfo.ticketId = "".concat((_message$metadata3 = message.metadata) === null || _message$metadata3 === void 0 ? void 0 : _message$metadata3.ticketId);
        }
        if (text && payload !== MessagePayload.INIT_MESSAGE) {
          hideTopBanner();
        }
        return message;
      },
      beforeSend: function beforeSend(message, _data) {
        message.metadata = _objectSpread({}, metaData);
        return message;
      },
      onInvalidAuth: function onInvalidAuth() {
        return fetchJwtAuth().then(function (auth) {
          var jwt = auth.jwt;
          if (!jwt) {
            return Promise.reject(new ChatError(new Error("Chat widget failed to get JWT from Zendesk API.")));
          }
          return new Promise(function (resolve) {
            return resolve(jwt);
          });
        });
      }
    }
  }).then(function () {
    displayTopBanner(strictLocalize);
    removeSunCoLogo();
    showInputField();
    addHotjarToIframeAttribute();
    var conversations = Smooch.getConversations();
    // If there are no conversations, create a new one and send the initial message
    if (conversations.length === 0) {
      Smooch.createConversation({
        metadata: {
          language: toConversationMetadataLanguage(metaData === null || metaData === void 0 ? void 0 : metaData.language)
        },
        messages: [{
          text: INIT_SEND_FAIRE_BOT_PROMPT_MESSAGE,
          type: "text",
          payload: MessagePayload.INIT_SEND_FAIRE_BOT_PROMPT,
          metadata: _objectSpread({}, metaData)
        }]
      });
    } else {
      var _conversations$;
      // If there are conversations, check if the conversation has messages
      if (((_conversations$ = conversations[0]) === null || _conversations$ === void 0 ? void 0 : _conversations$.messages.length) === 0) {
        var conversationId = conversations[0].id;
        // Update the conversation metadata with the new language selection before sending the init prompt message
        Smooch.updateConversation(conversationId, {
          metadata: {
            language: toConversationMetadataLanguage(metaData === null || metaData === void 0 ? void 0 : metaData.language)
          }
        }).then(function () {
          Smooch.sendMessage({
            type: "text",
            text: INIT_SEND_FAIRE_BOT_PROMPT_MESSAGE,
            payload: MessagePayload.INIT_SEND_FAIRE_BOT_PROMPT,
            metadata: _objectSpread({}, metaData)
          }, conversationId);
        });
      }
    }
  });
};
export var initChatAndUpdateLocalStorage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(auth, strictLocalize, metaData) {
    var errorToLog;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (metaData) {
            Storage.local.setItem(FAIRE_CHAT_METADATA, JSON.stringify(metaData));
          }
          _context.next = 4;
          return initChatWidget(auth, strictLocalize, metaData);
        case 4:
          _context.next = 10;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          errorToLog = _context.t0.name === "ChatError" ? _context.t0 : new ChatError(_context.t0);
          logWarning(errorToLog, {
            autoFingerprint: true
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function initChatAndUpdateLocalStorage(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var showChatWidget = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(auth, strictLocalize, metaData) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return initChatAndUpdateLocalStorage(auth, strictLocalize, metaData);
        case 2:
          Smooch.open();
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function showChatWidget(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
var hideChatWidget = function hideChatWidget() {
  Smooch.logout();
  Smooch.destroy();
  Storage.local.removeItem(FAIRE_CHAT_CSAT_FEEDBACK_SUBMITTED_STORAGE_KEY);
  Storage.local.removeItem(FAIRE_CHAT_METADATA);
};
Smooch.on("message:received", function (message, _data) {
  var role = message.role,
    displayName = message.displayName,
    payload = message.payload;
  if (role === FAIRE_BOT_ROLE && displayName === FAIRE_BOT_NAME) {
    if (payload === MessagePayload.END_TEXT_MESSAGE) {
      hideInputField();
      resetLocalStorageWhenChatEnds();
    } else if (payload === MessagePayload.CSAT_MESSAGE) {
      trackHelpCenterChatCsatView(zdAgentInfo.ticketId, "", getRetailerOrBrandCountry());
      hideInputField();
      resetLocalStorageWhenChatEnds();
    } else if (payload === MessagePayload.OFFLINE_MESSAGE) {
      hideInputField();
      resetLocalStorageWhenChatEnds();
    } else if (payload === MessagePayload.TRANSFER_MESSAGE) {
      var _getRetailerToken, _getBrandToken;
      var metaData = Storage.local.getItem(FAIRE_CHAT_METADATA);
      var _ref3 = metaData ? JSON.parse(metaData) : {},
        brand_order_token = _ref3.brand_order_token,
        email = _ref3.email,
        issue_type = _ref3.issue_type,
        tags = _ref3.tags;
      trackHelpCenterAllTypesOfTicketCreationSubmit((_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "", (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "", brand_order_token !== null && brand_order_token !== void 0 ? brand_order_token : "", email !== null && email !== void 0 ? email : "", "", "", "", issue_type !== null && issue_type !== void 0 ? issue_type : "", TicketType.CHAT, zdAgentInfo.ticketId, "", tags !== null && tags !== void 0 ? tags : "");
    }
  }
});
Smooch.on("widget:closed", function () {
  fetchConversation().then(function (conversation) {
    if (!conversation.is_conversation_started) {
      hideChatWidget();
    }
  });
});
Smooch.on("message:sent", function (message, _data) {
  var payload = message.payload;
  if (payload === MessagePayload.NPS_GOOD) {
    trackHelpCenterChatCsatSubmit(zdAgentInfo.ticketId, "Good", getRetailerOrBrandCountry());
    resetLocalStorageWhenChatEnds();
  } else if (payload === MessagePayload.NPS_BAD) {
    trackHelpCenterChatCsatSubmit(zdAgentInfo.ticketId, "Bad", getRetailerOrBrandCountry());
    resetLocalStorageWhenChatEnds();
  }
  return message;
});
var resetLocalStorageWhenChatEnds = function resetLocalStorageWhenChatEnds() {
  Storage.local.removeItem(FAIRE_CHAT_METADATA);
};
/**
 * Converts the given language from the `Language` enum string to the version that's expected in the Sunco
 * conversation metadata, which is the values for the "User Language Preference" ticket dropdown field in Zendesk.
 */
var toConversationMetadataLanguage = function toConversationMetadataLanguage(language) {
  switch (language) {
    case "ENG":
      return "langselect_us";
    case "FRA":
      return "langselect_fr";
    case "DEU":
      return "langselect_de";
    default:
      return "";
  }
};